// extracted by mini-css-extract-plugin
export default {"root":"styles_root__E1sKj","logo":"styles_logo__x67Ew","menuItem":"styles_menuItem__i5pnE","navItems":"styles_navItems__QHUjm","navItem":"styles_navItem__K3td+"};